// @ts-nocheck
import { name2num, num2name, } from "../../inside/authentication/RegistrationType";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../runtime/json/scalar";
import { WireType, } from "../../../runtime/wire/index";
import { default as serialize, } from "../../../runtime/wire/serialize";
import { default as Long, } from "../../../runtime/Long";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        provider: "REGISTRATION_TYPE_UNSPECIFIED",
        providerId: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.provider !== undefined)
        result.provider = tsValueToJsonValueFns.enum(value.provider);
    if (value.providerId !== undefined)
        result.providerId = tsValueToJsonValueFns.string(value.providerId);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.provider !== undefined)
        result.provider = jsonValueToTsValueFns.enum(value.provider);
    if (value.providerId !== undefined)
        result.providerId = jsonValueToTsValueFns.string(value.providerId);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.provider !== undefined) {
        const tsValue = value.provider;
        result.push([1, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    if (value.providerId !== undefined) {
        const tsValue = value.providerId;
        result.push([2, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.provider = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.providerId = value;
    }
    return result;
}
